export const FAVORITES_ENTITIES = {
  KNOWLEDGE: 'knowledge',
  CONTACT: 'contact',
  USER: 'user',
};
